import createPlugin from '@@/create-plugin';

export default createPlugin({
    components: {
        'page': () => import('./components/page'),
        'activate:editor': () => import('./components/activate'),
        'plugin:setting': () => import('./components/setting')
    }
});
